// src/components/CryptoNewsPanelFrontend.jsx
import React, { useEffect, useState } from "react";
import { Paper, Box, Typography, List, ListItem, ListItemText, Link, CircularProgress } from "@mui/material";
import { fetchCryptoNewsFrontend } from "../services/news";

export default function CryptoNewsPanelFrontend({ max = 6, feeds }) {
  const [loading, setLoading] = useState(true);
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const items = await fetchCryptoNewsFrontend(feeds, max);
        if (!mounted) return;
        setArticles(items);
      } catch (e) {
        console.error("frontend news fetch error", e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [max, feeds && feeds.join(",")]);

  if (loading) {
    return (
      <Paper sx={{ p: 2, borderRadius: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CircularProgress size={18} />
          <Typography>Loading crypto news…</Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 2, borderRadius: 2, height: "100%", overflow: "auto" }}>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>Latest Crypto News</Typography>
      <List dense>
        {articles.map((a, i) => (
          <ListItem key={a.link || i} sx={{ py: 0.5 }}>
            <ListItemText
              primary={<Link href={a.link} target="_blank" rel="noopener noreferrer" underline="hover">{a.title}</Link>}
              secondary={<Typography variant="caption" color="text.secondary">{a.source} • {a.pubDate ? new Date(a.pubDate).toLocaleString() : ""}</Typography>}
            />
          </ListItem>
        ))}
        {articles.length === 0 && <Typography variant="body2" color="text.secondary">No news available.</Typography>}
      </List>
    </Paper>
  );
}
